import type { ButtonHTMLAttributes, PropsWithChildren, ReactNode } from "react";

import type { ButtonSize } from "@/src/components/ui/Button/buttonClassName";

import { buttonClassName } from "@/src/components/ui/Button/buttonClassName";

export type ButtonProps = PropsWithChildren<
  {
    readonly darkBackground?: boolean;
    readonly size: ButtonSize;
  } & ButtonHTMLAttributes<HTMLButtonElement>
>;

export function Button({
  children,
  className,
  darkBackground = false,
  disabled = false,
  size,
  ...props
}: ButtonProps): ReactNode {
  return (
    <button
      className={buttonClassName(className, darkBackground, disabled, size)}
      {...props}
    >
      {children}
    </button>
  );
}
